module.exports = __webpack_public_path__ + "img/leftTop.31f47b6b.png";